import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IframeDialogComponent, LoadingSkeletonComponent } from '@components';
import { ProductUid } from '@constants';
import { GknFundamentalCardLink } from '@services';
import { firstValueFrom, Observable } from 'rxjs';
import { BreakpointService } from 'src/app/@shared/services/breakpoint/breakpoint.service';
import { HomeFundamentalsCardComponent } from '../home-fundamentals-card/home-fundamentals-card.component';
import { HomeFundamentalsCardType } from '../home-fundamentals-card/home-fundamentals-card.enum';
import { HomeFundamentalsReleaseNotesService } from './home-fundamentals-release-notes.service';

@Component({
    selector: 'app-home-fundamentals-release-notes',
    templateUrl: './home-fundamentals-release-notes.component.html',
    styleUrls: ['./home-fundamentals-release-notes.component.scss'],
    imports: [
        CommonModule,
        HomeFundamentalsCardComponent,
        LoadingSkeletonComponent,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatTooltipModule,
    ],
    providers: [HomeFundamentalsReleaseNotesService],
})
export class HomeFundamentalsReleaseNotesComponent implements OnInit {
    private breakpointService = inject(BreakpointService);
    private dialog = inject(MatDialog);
    private releaseNotesService = inject(HomeFundamentalsReleaseNotesService);

    cardType = HomeFundamentalsCardType.RELEASE_NOTES;
    releaseNotes$: Observable<{ links: GknFundamentalCardLink[]; action?: GknFundamentalCardLink }>;
    productEnum = ProductUid;

    ngOnInit(): void {
        this.releaseNotes$ = this.releaseNotesService.releaseNotes$;
    }

    handleOpenDialog(link: GknFundamentalCardLink) {
        firstValueFrom(this.breakpointService.mobile$)
            .then((mobile) => {
                // Release notes are kept on the Genesys Resource Center, which has a simplified theme for removing their header and footer in our iframe.
                const url = new URL(link.url);
                url.searchParams.set('theme', 'simplified');

                this.dialog.open(IframeDialogComponent, {
                    width: mobile ? '' : '80%',
                    maxWidth: BreakpointService.contentMaxWidth,
                    height: mobile ? '90%' : '80%',
                    autoFocus: false,
                    data: {
                        title: HomeFundamentalsCardType.RELEASE_NOTES,
                        subtitle: link.label,
                        src: url.toString(),
                    },
                });
            })
            .catch((e) => {
                throw e;
            });
    }
}
